module.exports = __webpack_public_path__ + "static/img/pbrand3.514a1288.png";